module.exports = __webpack_public_path__ + "media/process/Process3-b40379d1.jpg";